// Auth
// login firebase auth
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// logout firebase auth
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const CHECK_USER_SESSION = 'CHECK_USER_SESSION';

// Client
// create client
export const CREATE_CLIENT_AND_PET_REQUEST = 'CREATE_CLIENT_AND_PET_REQUEST';
export const CREATE_CLIENT_AND_PET_SUCCESS = 'CREATE_CLIENT_AND_PET_SUCCESS';
export const CREATE_CLIENT_AND_PET_FAILURE = 'CREATE_CLIENT_AND_PET_FAILURE';

// get all clients
export const GET_ALL_CLIENTS_REQUEST = 'GET_ALL_CLIENTS_REQUEST';
export const GET_ALL_CLIENTS_SUCCESS = 'GET_ALL_CLIENTS_SUCCESS';
export const GET_ALL_CLIENTS_FAILURE = 'GET_ALL_CLIENTS_FAILURE';

// get all clients
export const GET_SINGLE_CLIENT_DATA_REQUEST = 'GET_SINGLE_CLIENT_DATA_REQUEST';
export const GET_SINGLE_CLIENT_DATA_SUCCESS = 'GET_SINGLE_CLIENT_DATA_SUCCESS';
export const GET_SINGLE_CLIENT_DATA_FAILURE = 'GET_SINGLE_CLIENT_DATA_FAILURE';

// edit client data form
export const EDIT_CLIENT_DATA_REQUEST = 'EDIT_CLIENT_DATA_REQUEST';
export const EDIT_CLIENT_DATA_SUCCESS = 'EDIT_CLIENT_DATA_SUCCESS';
export const EDIT_CLIENT_DATA_FAILURE = 'EDIT_CLIENT_DATA_REQUEST';

// edit client data form
export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE';

// Pet
// create pet
export const CREATE_PET_REQUEST = 'CREATE_PET_REQUEST';
export const CREATE_PET_SUCCESS = 'CREATE_PET_SUCCESS';
export const CREATE_PET_FAILURE = 'CREATE_PET_FAILURE';

// get all pets
export const GET_ALL_PETS_REQUEST = 'GET_ALL_PETS_REQUEST';
export const GET_ALL_PETS_SUCCESS = 'GET_ALL_PETS_SUCCESS';
export const GET_ALL_PETS_FAILURE = 'GET_ALL_PETS_FAILURE';

// edit client data form
export const EDIT_PET_DATA_REQUEST = 'EDIT_PET_DATA_REQUEST';
export const EDIT_PET_DATA_SUCCESS = 'EDIT_PET_DATA_SUCCESS';
export const EDIT_PET_DATA_FAILURE = 'EDIT_PET_DATA_FAILURE';

// edit client data form
export const GET_PET_DATA_REQUEST = 'GET_PET_DATA_REQUEST';
export const GET_PET_DATA_SUCCESS = 'GET_PET_DATA_SUCESS';
export const GET_PET_DATA_FAILURE = 'GET_PET_DATA_FAILURE';


// edit client data form
export const DELETE_PET_REQUEST = 'DELETE_PET_REQUEST';
export const DELETE_PET_SUCCESS = 'DELETE_PET_SUCCESS';
export const DELETE_PET_FAILURE = 'DELETE_PET_FAILURE';


// Treatment
// edit client data form
export const EDIT_TREATMENT_DATA_REQUEST = 'EDIT_TREATMENT_DATA_REQUEST';
export const EDIT_TREATMENT_DATA_SUCCESS = 'EDIT_TREATMENT_DATA_SUCCESS';
export const EDIT_TREATMENT_DATA_FAILURE = 'EDIT_TREATMENT_DATA_FAILURE';

// edit client data form
export const GET_SINGLE_PET_TREATMENTS_REQUEST = 'GET_SINGLE_PET_TREATMENTS_REQUEST';
export const GET_SINGLE_PET_TREATMENTS_SUCCESS = 'GET_SINGLE_PET_TREATMENTS_SUCCESS';
export const GET_SINGLE_PET_TREATMENTS_FAILURE = 'GET_SINGLE_PET_TREATMENTS_FAILURE';

// edit client data form
export const ADD_SINGLE_TREATMENT_REQUEST = 'ADD_SINGLE_TREATMENT_REQUEST';
export const ADD_SINGLE_TREATMENT_SUCCESS = 'ADD_SINGLE_TREATMENT_SUCCESS';
export const ADD_SINGLE_TREATMENT_FAILURE = 'ADD_SINGLE_TREATMENT_FAILURE';

// edit client data form
export const GET_TREATMENT_DATA_REQUEST = 'GET_TREATMENT_DATA_REQUEST';
export const GET_TREATMENT_DATA_FAILURE = 'GET_TREATMENT_DATA_FAILURE';
export const GET_TREATMENT_DATA_SUCCESS = 'GET_TREATMENT_DATA_SUCCESS';

// edit client data form
export const DELETE_TREATMENT_REQUEST = 'DELETE_TREATMENT_REQUEST';
export const DELETE_TREATMENT_SUCCESS = 'DELETE_TREATMENT_SUCCESS';
export const DELETE_TREATMENT_FAILURE = 'DELETE_TREATMENT_FAILURE';

// send message
export const SEND_SMS_REQUEST = 'SEND_SMS_REQUEST';
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS';
export const SEND_SMS_FAILURE = 'SEND_SMS_FAILURE';

// send email
export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';
